import { ImportDetails, Person } from '@/models/Person';
import { User } from '@/models/User';
import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import _ from 'underscore';
import { ListViewPeopleData, People, PeopleState, PeopleTypes } from './types';

const initialStateContentList: ListViewPeopleData = {
    list: [] as Person[],
    total: 0,
    loading: true,
};

const INITIAL_STATE: PeopleState = {
    data: {
        listOfPeople: { ...initialStateContentList },
        listOfUser: [] as User[],
        importDetails: [] as ImportDetails[],
        importDetailsTotal: 0,
    } as People,
    person: undefined,
    publicPerson: undefined,
    totalActives: 0,
    totalRegistered: 0,
    loading: false,
    hasError: false,
    error: undefined,
    success: false,
    processingActivation: false,
    myPerson: undefined,
    successOnPutPerson: undefined,
};

const processRequestList = (currList: any[], newList: any[]) => {
    return _.chain(currList.concat(newList))
        .filter((item: any) => Boolean(item && item.id))
        .uniq(false, (item: any) => item.id)
        .value();
};

const reducer: Reducer<PeopleState> = (state: PeopleState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case PeopleTypes.GET_PERSON_REQUEST:
            return { ...state, loading: true };
        case PeopleTypes.GET_PERSON_SUCCESS:
            return {
                ...state,
                loading: false,
                person: action.payload,
            };
        case PeopleTypes.GET_PERSON_CLEAR:
            return {
                ...state,
                loading: false,
                success: false,
                hasError: false,
                error: undefined,
                person: undefined,
                successOnPutPerson: undefined,
            };
        case PeopleTypes.GET_PEOPLE_REQUEST:
            return { ...state, loading: true };
        case PeopleTypes.GET_PEOPLE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    listOfPeople: {
                        ...state.data.listOfPeople,
                        list: processRequestList([...state.data.listOfPeople.list], [...action.payload.listOfPeople.list]),
                        total: action.payload.listOfPeople.total,
                        loading: false,
                    },
                    listOfUser: processRequestList([...state.data.listOfUser], [...action.payload.listOfUser]),
                },
            };
        case PeopleTypes.ACTIVE_REQUEST: {
            return { ...state, loading: false, processingActivation: true };
        }
        case PeopleTypes.ACTIVE_SUCCESS: {
            const index = state.data.listOfUser.findIndex((u) => u.id === action.payload.userId);
            state.data.listOfUser[index].activated = action.payload.activate;
            return {
                ...state,
                loading: false,
                success: true,
                hasError: false,
                processingActivation: false,
            };
        }
        case PeopleTypes.POST_PERSON_SUCCESS: {
            return {
                ...state,
                data: { ...state.data, ...action.payload },
                success: true,
                hasError: false,
            };
        }
        case PeopleTypes.PUT_PERSON_REQUEST: {
            return {
                ...state,
                success: false,
                successOnPutPerson: undefined,
                loading: true,
                hasError: false,
            };
        }
        case PeopleTypes.PUT_PERSON_SUCCESS: {
            return {
                ...state,
                data: { ...state.data, ...action.payload },
                success: true,
                successOnPutPerson: true,
                loading: false,
                hasError: false,
            };
        }
        case PeopleTypes.HANDLE_PERSON_FAILURE:
            return {
                ...state,
                success: false,
                successOnPutPerson: false,
                hasError: true,
                loading: false,
                error: action.payload,
            };
        case PeopleTypes.FIRST_ACCESS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PeopleTypes.FIRST_ACCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case PeopleTypes.FIRST_ACCESS_FAILURE:
            return {
                ...state,
                loading: false,
                hasError: true,
                success: false,
            };
        case PeopleTypes.GET_IMPORT_HISTORY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PeopleTypes.GET_IMPORT_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                data: { ...state.data, importHistory: action.payload },
            };
        case PeopleTypes.GET_IMPORT_HISTORY_FAILURE:
            return {
                ...state,
                loading: false,
                hasError: true,
                success: false,
            };
        case PeopleTypes.GET_IMPORT_DETAIL_REQUEST:
            return {
                ...state,
                loading: true,
                data: { ...state.data, importDetails: undefined, importDetailsTotal: undefined },
            };
        case PeopleTypes.GET_IMPORT_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                data: { ...state.data, importDetails: action.payload.data, importDetailsTotal: action.payload.total },
            };
        case PeopleTypes.GET_IMPORT_DETAIL_FAILURE:
            return {
                ...state,
                loading: false,
                hasError: true,
                success: false,
            };
        case PeopleTypes.GET_IMPORT_DETAIL_CLEAR:
        case PeopleTypes.GET_IMPORT_HISTORY_CLEAR:
        case PeopleTypes.GET_PEOPLE_FAILURE:
        case PeopleTypes.ACTIVE_FAILURE:
        case PeopleTypes.FORGOT_PASSWORD_FAILURE:
        case PeopleTypes.GET_PEOPLE_CLEAR:
            return {
                ...state,
                data: {
                    ...state.data,
                    listOfPeople: { ...initialStateContentList },
                    listOfUser: [],
                },
            };
        case PeopleTypes.GET_TOTAL_ACTIVE_PEOPLE_REQUEST:
            return { ...state, loading: true };
        case PeopleTypes.GET_TOTAL_ACTIVE_PEOPLE_SUCCESS:
            return { ...state, totalActives: action.payload, loading: false };
        case PeopleTypes.GET_TOTAL_REGISTERED_PEOPLE_SUCCESS:
            return { ...state, totalRegistered: action.payload, loading: false };
        case PeopleTypes.GET_TOTAL_ACTIVE_PEOPLE_FAILURE:
            return { ...state, loading: false, hasError: true };
        case PeopleTypes.REFRESH_MY_PERSON_REQUEST:
            return { ...state, hasError: false };
        case PeopleTypes.REFRESH_MY_PERSON_SUCCESS:
            return { ...state, hasError: false, myPerson: action.payload };
        case PeopleTypes.REFRESH_MY_PERSON_FAILURE:
            return { ...state, hasError: true, error: action.payload };
        case PeopleTypes.GET_PUBLIC_PERSON_REQUEST:
            return { ...state, success: false, hasError: false, loading: true, error: undefined };
        case PeopleTypes.GET_PUBLIC_PERSON_SUCCESS:
            return { ...state, success: true, hasError: false, loading: false, error: undefined, publicPerson: action.payload };
        case PeopleTypes.GET_PUBLIC_PERSON_FAILURE:
            return { ...state, success: false, hasError: true, loading: false, error: action.payload };
        case PeopleTypes.GET_PUBLIC_PERSON_CLEAR:
            return { ...state, success: false, hasError: false, loading: false, error: undefined, publicPerson: undefined };
        case PeopleTypes.HANDLE_PERSON_CLEAR:
            return { ...state, loading: false, hasError: false, success: false };
        default:
            return state;
    }
};

export default reducer;
